<template>
    <BottomList :QueryData="QueryData" />
</template>

<script>
import BottomList from './BottomList.vue'
export default {
    props: ['detailNetObj'],
    components: {
        BottomList
    },
    data() {
        return {
            QueryData: []
        }
    },
    activated() {
        this.QueryData = [...this.detailNetObj]
    }
}
</script>

<style>
</style>